import { useCallback } from 'react'
import { batch } from 'react-redux'
import { useAppDispatch } from '@/state/hooks'
import { setChainId, setFromToken } from './reducer'
import { Native } from '@/lib/cryptoCurrency'
import { ChainId } from '@/lib/chain'

export function useSwitchChain(): (chainId: ChainId) => void {
  const dispatch = useAppDispatch()
  return useCallback(
    (chainId: ChainId) => {
      const newToken = Native.onChain(chainId).serialize()

      batch(() => {
        dispatch(setChainId(chainId))
        dispatch(setFromToken(newToken))
      })
    },
    [dispatch]
  )
}
